import * as React from "react";
import externalInterfaceStore from "stores/ExternalInterfaceStore";

export const GdsFakeActionButtonContainer = ({ children }: { children: React.ReactNode }) => (
    <div
        style={{
            padding: "32px 16px",
            display: "flex",
            gap: 16,
            flexDirection: externalInterfaceStore.isGeorgeApp ? "column" : "row",
            justifyContent: "center",
            flexWrap: "wrap"
        }}
    >
        {children}
    </div>
);



// WEBPACK FOOTER //
// ./src/components/common/GdsFakeActionButtonContainer.tsx